/* eslint react/prop-types: 0 */
import { FormInput } from 'camino-react'
import React from 'react'
import Select from 'react-select'

const ChangeStatusAction = ({
  update,
  operations: { status_id: statusID },
  options: { ticketStatuses }
}) => (
  <FormInput label="Status">
    <Select
      value={statusID}
      onChange={e => update('status_id', e.value)}
      options={(ticketStatuses)}
    />
  </FormInput>
)

export default ChangeStatusAction
